import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function Empty({ onsiteManifest = false }) {
  return (
    <>
      <Box
        mt={3}
        mx={2}
        component="img"
        borderRadius={3}
        width="100%"
        maxWidth={400}
        minHeight="258px"
        src="/empty-shipment.webp"
      />
      <Typography mt={4} maxWidth={400} fontWeight={500} align="center">
        {onsiteManifest
          ? "Tap Add Item to open the onsite manifest and validate items by rack."
          : "All shipments contain items. Please list the items included in this shipment below:"}
      </Typography>
    </>
  );
}
